import { api, ApiRes } from './_api-client';

export enum LogLevel {
  'Info',
  'Error',
  'Fatal',
}

export interface ParsedError {
  name: string;
  message: string;
  stack?: string;
}

export interface LogBody {
  userId: number | null;
  projectId: number | null;
  storyId: number | null;
  finalCutId: number | null;
  finalCutVersionId: number | null;
  level: LogLevel;
  error: ParsedError;
}

export const Log = (body: LogBody) => {
  return api.post<ApiRes>(`/Logger/Log`, body);
};
